"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Error_1 = require("./_Error");
exports._Errors = {
    type: "list",
    flattened: true,
    member: {
        shape: _Error_1._Error
    }
};
//# sourceMappingURL=_Errors.js.map